import { useEffect } from 'react';

interface PlayShortcuts {
  status: string;
  hasOutcome: boolean;
  onPause: () => void;
  onResume: () => void;
  onRestart: () => void;
}

/** R remains available for lane input until the run is paused or finished. */
export function usePlayShortcuts({
  status, hasOutcome, onPause, onResume, onRestart,
}: PlayShortcuts) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      const target = event.target;
      if (event.repeat || event.ctrlKey || event.altKey || event.metaKey) {
        return;
      }
      if (target instanceof HTMLElement && (
        target.matches('input:not([type="checkbox"]), textarea, select') || target.isContentEditable
      )) {
        return;
      }
      const key = event.key.toLowerCase();
      if ((key === 'p' || key === 'escape') && !hasOutcome) {
        if (status === 'paused') {
          event.preventDefault();
          onResume();
        } else if (status === 'running' || status === 'lead_in') {
          event.preventDefault();
          onPause();
        }
      } else if (key === 'r' && (hasOutcome || status === 'paused')) {
        event.preventDefault();
        onRestart();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [status, hasOutcome, onPause, onResume, onRestart]);
}
